import CryptoJS from 'crypto-js/crypto-js' // 引用AES源码js
import { KJUR, hextob64 } from 'jsrsasign'

const key = CryptoJS.enc.Utf8.parse('znT4VmKA%ksP**7x') // 十六位十六进制数作为密钥
const iv = CryptoJS.enc.Utf8.parse('d#$5a@Bp^udR4XuZ') // 十六位十六进制数作为密钥偏移量

const keyForMobile = CryptoJS.enc.Utf8.parse('+X9tj1JQxg9xUF8r')
const ivForMobile = CryptoJS.enc.Utf8.parse('eg3vvKneGcJIyAqG')

// 解密方法
const DecryptMobile = function (word) {
  return DecryptWithKeyIV(word, keyForMobile, ivForMobile)
}

const EncryptMobile = function (word) {
  return EncryptWithKeyIV(word, keyForMobile, ivForMobile)
}

const Decrypt = function (word) {
  return DecryptWithKeyIV(word, key, iv)
}

const Encrypt = function (word) {
  return EncryptWithKeyIV(word, key, iv)
}

const DecryptWithKeyIV = function (word, key, iv) {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word)
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr)
  let decrypt = CryptoJS.AES.decrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}

const EncryptWithKeyIV = function (word, key, iv) {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.ciphertext.toString().toUpperCase()
}

// RSA 签名后转base64
const SignatureByRSA = function (data) {
  // const hash = CryptoJS.SHA256(data).toString(CryptoJS.enc.Hex)
  const rsa = new KJUR.crypto.Signature({ alg: 'SHA256withRSA' })
  rsa.init(Decrypt(window.privKey))
  rsa.updateString(data)
  const signature = hextob64(rsa.sign())
  return signature
}

export {
  Decrypt,
  Encrypt,
  SignatureByRSA,
  DecryptMobile,
  EncryptMobile
}
